import { SVGInterface } from "../../interface";

const ViewVertical = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M17 3L7 3C5.9 3 5 3.9 5 5L5 19C5 20.1 5.9 21 7 21L17 21C18.1 21 19 20.1 19 19L19 5C19 3.9 18.1 3 17 3ZM7 19L7 5L11 5L11 19L7 19ZM13 5L17 5L17 19L13 19L13 5Z"
      fill={color || "#0E171F"}
    />
  </svg>
);
export default ViewVertical;
